export default ({ get, checkStatus, toJSON }) => ({
  getHomeSpotlight: () =>
    get("universe/v1/home_page_spotlight").then(checkStatus).then(toJSON),
});
